import { render, staticRenderFns } from "./MusicHistoryTable.vue?vue&type=template&id=20200d00&scoped=true&"
import script from "./MusicHistoryTable.vue?vue&type=script&lang=js&"
export * from "./MusicHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./MusicHistoryTable.vue?vue&type=style&index=0&id=20200d00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20200d00",
  null
  
)

export default component.exports